import React = require('react');
import { filter, flow, get, head } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { mtaActions } from '../../../../services/mta/actions';
import { withRouter } from 'react-router';
import { InfoAnnie } from '../../../../components/InfoAnnie';
import { actions as contentActions } from '../../../../services/content/reducer';
import { IContentActions, IContentState } from '../../../../services/content/models';
import { IAuthState } from '../../../../services/auth/models';
import Navigation from './Components/Navigation';
import { windowSize } from '../../../../hooks/windowSize';
import EmergencyMessaging, { EmergencyMessagingEnum } from '../../../../components/EmergencyMessaging';
import * as Commonmark from 'react-commonmark';
import { CancellationAnnieBanner } from '../../../../components/CancellationAnnieBanner';
import { PolicyAnnieBanner } from '../../../../components/PolicyAnnieBanner';
import { QuoteAnnieBanner } from '../../../../components/QuoteAnnieBanner';
import { ICustomerMTAOptions } from '../../../CustomerAreaNew/scenes/MakeAChange';
import { IPolicyApplication } from '../../../../data/api/models';
import { IMtaActions } from '../../../../services/mta/models';

interface IPortalHeader {
  auth: IAuthState;
  location: any;
  content: IContentState;
  actions: {
    content: IContentActions;
    push: (route: string) => void;
    mta: IMtaActions;
    auth: IAuthActions;
  }
  customerMTAOptions: ICustomerMTAOptions
  quoteApplication: IPolicyApplication
}

export const PortalHeader = ({
                               auth,
                               actions,
                               content,
                               customerMTAOptions,
                               quoteApplication,
                               ...props
                             }: IPortalHeader) => {

  const welcomeContent = head(filter(content?.content, ['name', 'Welcome Messaging'])) || null;
  const customerName = get(auth, 'customer.firstName', '')
  const isMobile = windowSize(480).isMobile;
  const pathName = get(props, 'location.pathname', '')
  const allowWelcomeMessage = ['/account/summary', '/account/claims', '/account/offers'].includes(pathName)
  const hideAnnie = ['/account/claims'].includes(pathName)
  const welcomeText = get(welcomeContent, 'metadata.enabled', false) && get(welcomeContent, 'sections.message', '');
  const mtaOptions = actions.mta.getCustomerMtaOptions();
  const claimsSSOEnabled = get(mtaOptions, 'other.enable_claims_sso', false)

  return (
    <div className={'container'}>
      <div className={'header-content-container'}>
        {allowWelcomeMessage && <div className={'header-content'}>
          {customerName && !hideAnnie && (
            <div style={{ maxWidth: '600px' }}>
              <InfoAnnie title={'Welcome back, ' + customerName + '!'}
                         text={welcomeText ? (<Commonmark linkTarget="_blank" source={welcomeText}/>) : ''}/>
            </div>
          )}
          <div style={{ marginTop: '15px' }}>
            <EmergencyMessaging type={EmergencyMessagingEnum.PORTAL}/>
          </div>
        </div>}
      </div>
      <Navigation
        location={props.location}
        actions={actions}
        isMobile={isMobile}
        auth={auth}
        claimsSSOEnabled={claimsSSOEnabled}
      />
      <CancellationAnnieBanner customerName={customerName} pathName={pathName}/>
      <PolicyAnnieBanner pathName={pathName}/>
      <QuoteAnnieBanner
        pathName={pathName}
        customerName={customerName}
        quoteApplication={quoteApplication}
        customerMTAOptions={customerMTAOptions}
      />
    </div>
  )
}

export default flow([
  connect(
    (state: IStore) => ({
      auth: state.auth,
      content: state.content,
      customerMTAOptions: get(state.branding.channel.products[0], 'metadata.direct_customer_mta_options', null),
      quoteApplication: state?.quote?.application || null
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        content: bindActionCreators({ ...contentActions }, dispatch)
      },
    }),
  ),
  withRouter,
])(PortalHeader);
